import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    memberCount: (count: number) => string | React.ReactNode;
    copyLink: string;
    downloadAllFiles: string;
    inviteLabel: string;
    inviteMembers: string;
    manageMembers: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label for the project member count shown in the project switcher sheet header */
            memberCount: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number) => { return __intl__.intl().formatMessage({ id: "ProjectSwitcherSheetHeader.memberCount.0?c=3ntjf0u81br9c", defaultMessage: "{count, plural, one {1 Member} other {{count, number, ::compact-short} Members}}" }, { count: count }); });
                },
                enumerable: true,
                configurable: true
            },
            /** Context menu action label for copying the current project's URL */
            copyLink: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectSwitcherSheetHeader.copyLink?c=3c8djzli68xet", defaultMessage: "Copy Project URL" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Context menu action label for downloading all assets in the project */
            downloadAllFiles: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectSwitcherSheetHeader.downloadAllFiles?c=vmh79u9lkb2g", defaultMessage: "Download All Assets" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the invite/members access control button in the project switcher header */
            inviteLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectSwitcherSheetHeader.inviteLabel?c=3dx8d6bjgazen", defaultMessage: "Invite to Project" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu item label for inviting people to the current project */
            inviteMembers: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectSwitcherSheetHeader.inviteMembers?c=3akii96mywnxz", defaultMessage: "Invite Members" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu item label for managing existing project members */
            manageMembers: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectSwitcherSheetHeader.manageMembers?c=tklamxbrwz1l", defaultMessage: "Manage Members" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
